import { render } from "./WhyPage.vue?vue&type=template&id=fb272d76&scoped=true"
import script from "./WhyPage.vue?vue&type=script&lang=js"
export * from "./WhyPage.vue?vue&type=script&lang=js"

import "./WhyPage.vue?vue&type=style&index=0&id=fb272d76&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb272d76"]])

export default __exports__